var render, staticRenderFns
import script from "./BenefitChart.vue?vue&type=script&lang=js"
export * from "./BenefitChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f659e95",
  null
  
)

export default component.exports